// @flow
import featureTesting from 'Components/utils/feature-testing/FeatureTesting';
import get from 'lodash/get';

export function localStorageAvailable() {
  return featureTesting.getTestResult('localstorage');
}

function safeJSONParse(o: Object) {
  try {
    return JSON.parse(o);
  } catch (e) {
    return null;
  }
}

export function setInLocalStorage(
  key: string,
  value: *,
  // Date.now is injected for test purposes
  { ttl, date = Date.now() }: { ttl: number, date?: number } = {},
) {
  if (localStorageAvailable()) {
    localStorage.setItem(
      key,
      JSON.stringify({
        value,
        expireTs: ttl ? date + ttl : null,
      }),
    );
  }
}

// Date.now is injected for test purposes
export function getFromLocalStorage(key: string, date?: number = Date.now()) {
  if (localStorageAvailable()) {
    const item = safeJSONParse(localStorage.getItem(key));
    const expireTs = item && item.expireTs;
    if (expireTs && expireTs <= date) {
      remove(key);
      return null;
    }
    return get(item, 'value') || null;
  }
  return null;
}

export function remove(key: string) {
  if (localStorageAvailable()) {
    localStorage.removeItem(key);
  }
}

export function clearLocalStorage() {
  if (localStorageAvailable()) {
    localStorage.clear();
  }
}
